export default "__VITE_ASSET__9K2ht3q9__"